import React, { Suspense } from 'react'

import { Route } from 'react-router-dom'

import { Loader } from '@driftt/tide-core'

export interface Props {
  exact?: boolean
  path?: string | string[]
  lazyComponent?: React.LazyExoticComponent<any>
}

const LazyRoute: React.FC<Props> = ({
  exact,
  path,
  lazyComponent: LazyComponent,
}) => (
  <Route
    exact={exact}
    path={path}
    render={() => (
      <Suspense fallback={() => <Loader />}>
        {LazyComponent && <LazyComponent />}
      </Suspense>
    )}
  />
)

export default LazyRoute
